import type { HTMLMotionProps } from 'framer-motion';
import type React from 'react';

import { m } from 'framer-motion';

import MotionLazy from './MotionLazy';

const MDivStyles = {
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: '100%' },
  initial: { opacity: 0, y: '100%' },
  style: { height: '100%', width: '100%' },
};

// `HTMLMotionProps<'div'>`, not `React.HTMLProps<HTMLDivElement>`: framer-motion
// REDEFINES several DOM handlers on `m.div` — `onAnimationStart` takes an
// `AnimationDefinition` there, not a React `AnimationEvent` — so a plain DOM
// props type cannot be spread onto it. That conflict is what the `@ts-ignore`
// below the `MotionLazy` used to hide, and it hid every other prop error along
// with it.
interface MotionSlideInProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  className?: string;
  duration?: number;
  delay?: number;
}

const MotionSlideIn: React.FC<MotionSlideInProps> = ({
  children,
  className,
  delay = 0,
  duration = 0.4,
  ...rest
}) => (
  <MotionLazy>
    <m.div
      transition={{ bounce: 0.2, delay, duration, type: 'spring' }}
      initial={MDivStyles.initial}
      animate={MDivStyles.animate}
      style={MDivStyles.style}
      exit={MDivStyles.exit}
      className={className}
      {...rest}
    >
      {children}
    </m.div>
  </MotionLazy>
);

export default MotionSlideIn;
